import moment from 'moment'

const commonFilters = {
    filters: {
        cutString (val, length) {
            if (val) {
                val = val.length > length ? val.slice(0, length).concat('...') : val;
            }
            return val
        }
    }
}

const debounce = function (f, ms) {

    let isCooldown = false;
  
    return function() {
      if (isCooldown) return;
  
      f.apply(this, arguments);
  
      isCooldown = true;
  
      setTimeout(() => isCooldown = false, ms);
    };
  
}

const statuses = {
    methods: {
        isClosed: (end) => {
            return moment().isAfter(end);
        },
        notStarted: (start) => {
            return new Date(start) >= new Date()
        },
        getStatus: (start, end) => {
            let result = null;
            if (statuses.methods.isClosed(end)) {
                result = 'old'
            } else if (statuses.methods.notStarted(start)) {
                result = 'future'
            } else {
                result = 'active'
            }
            return result;
        }
    }
}


export {commonFilters, debounce, statuses}